var map = {
	"./1.wav": "Nrk5",
	"./10.wav": "r/yS",
	"./11.wav": "N6lK",
	"./12.wav": "aZ8k",
	"./13.wav": "6rwP",
	"./14.wav": "tVhr",
	"./15.wav": "fExL",
	"./16.wav": "R04J",
	"./17.wav": "ALfh",
	"./18.wav": "YsKn",
	"./19.wav": "b+s+",
	"./2.wav": "Qz34",
	"./20.wav": "9dUu",
	"./21.wav": "n2Zn",
	"./22.wav": "5KSL",
	"./23.wav": "WY8p",
	"./24.wav": "QTn/",
	"./25.wav": "v/fB",
	"./26.wav": "5H3Z",
	"./27.wav": "3WQ/",
	"./28.wav": "E4bQ",
	"./29.wav": "oPnG",
	"./3.wav": "UYWm",
	"./30.wav": "goiA",
	"./31.wav": "5+UO",
	"./32.wav": "xWXF",
	"./33.wav": "mzGt",
	"./34.wav": "70KS",
	"./35.wav": "aHtN",
	"./36.wav": "m7S6",
	"./37.wav": "55xb",
	"./38.wav": "saWv",
	"./39.wav": "wpmN",
	"./4.wav": "SRwP",
	"./40.wav": "hyf6",
	"./41.wav": "nqz4",
	"./42.wav": "9YTN",
	"./43.wav": "fDD/",
	"./44.wav": "j6PJ",
	"./45.wav": "Wl9g",
	"./46.wav": "SoLO",
	"./47.wav": "DT7f",
	"./48.wav": "llgW",
	"./49.wav": "vQ+A",
	"./5.wav": "rK+R",
	"./50.wav": "vtHb",
	"./51.wav": "cHmA",
	"./52.wav": "YOMG",
	"./53.wav": "Heby",
	"./54.wav": "OrG3",
	"./55.wav": "Jia4",
	"./56.wav": "2S+N",
	"./57.wav": "itQf",
	"./58.wav": "hMq/",
	"./59.wav": "mLPH",
	"./6.wav": "qsC2",
	"./60.wav": "1yUm",
	"./61.wav": "z1hU",
	"./62.wav": "h1b3",
	"./63.wav": "oHgx",
	"./64.wav": "18X8",
	"./65.wav": "4P0Y",
	"./66.wav": "zMV3",
	"./67.wav": "qjA2",
	"./68.wav": "TyPE",
	"./69.wav": "peOK",
	"./7.wav": "zXM7",
	"./70.wav": "I4P6",
	"./71.wav": "lvXO",
	"./72.wav": "irPf",
	"./73.wav": "vKUH",
	"./74.wav": "o3nS",
	"./75.wav": "MQgm",
	"./76.wav": "+lj6",
	"./77.wav": "drGb",
	"./78.wav": "nGDd",
	"./79.wav": "FCnE",
	"./8.wav": "QsxX",
	"./80.wav": "UgZ0",
	"./81.wav": "G7Ub",
	"./82.wav": "SO5J",
	"./83.wav": "zNaR",
	"./84.wav": "RQXK",
	"./85.wav": "lfPe",
	"./86.wav": "SSvj",
	"./87.wav": "IlhY",
	"./88.wav": "wfpQ",
	"./9.wav": "lc3g",
	"./majors/1.wav": "5x/k",
	"./majors/2.wav": "LD69",
	"./majors/3.wav": "Thui",
	"./majors/4.wav": "z9Ws",
	"./majors/5.wav": "I+Ol",
	"./majors/6.wav": "CGau",
	"./majors/7.wav": "uJtb",
	"./sing/majorA1.wav": "Uhhf",
	"./sing/majorA2.wav": "/QCr",
	"./sing/majorA3.wav": "/4sn",
	"./sing/majorA4.wav": "S8eu",
	"./sing/majorA5.wav": "Y2Q3",
	"./sing/majorA6.wav": "Qw/e",
	"./sing/majorA7.wav": "GItl",
	"./sing/majorB1.wav": "8T+c",
	"./sing/majorB2.wav": "CSmY",
	"./sing/majorB3.wav": "D63k",
	"./sing/majorB4.wav": "8wED",
	"./sing/majorB5.wav": "mLKa",
	"./sing/majorB6.wav": "OXkW",
	"./sing/majorB7.wav": "jY2c",
	"./sing/majorC1.wav": "Pqa1",
	"./sing/majorC2.wav": "vDQF",
	"./sing/majorC3.wav": "+CU1",
	"./sing/majorC4.wav": "0XE8",
	"./sing/majorC5.wav": "KQ7j",
	"./sing/majorC6.wav": "81w/",
	"./sing/majorC7.wav": "R4lq",
	"./sing/majorD1.wav": "byR7",
	"./sing/majorD2.wav": "AOFL",
	"./sing/majorD3.wav": "l7/M",
	"./sing/majorD4.wav": "8RU4",
	"./sing/majorD5.wav": "GMjL",
	"./sing/majorD6.wav": "OgLN",
	"./sing/majorD7.wav": "ULqa",
	"./sing/majorE1.wav": "1fGi",
	"./sing/majorE2.wav": "tso0",
	"./sing/majorE3.wav": "M4Nm",
	"./sing/majorE4.wav": "IZuE",
	"./sing/majorE5.wav": "mQ56",
	"./sing/majorE6.wav": "T5W5",
	"./sing/majorE7.wav": "wcc8",
	"./sing/majorF1.wav": "WVd4",
	"./sing/majorF2.wav": "Wchq",
	"./sing/majorF3.wav": "zYQS",
	"./sing/majorF4.wav": "hnS/",
	"./sing/majorF5.wav": "EGKx",
	"./sing/majorF6.wav": "eZIH",
	"./sing/majorF7.wav": "eWUq",
	"./sing/majorG1.wav": "AYvt",
	"./sing/majorG2.wav": "HyAv",
	"./sing/majorG3.wav": "yfCy",
	"./sing/majorG4.wav": "cFix",
	"./sing/majorG5.wav": "wmvI",
	"./sing/majorG6.wav": "AA/S",
	"./sing/majorG7.wav": "Y3qO",
	"./test/1.wav": "rd5l",
	"./test/2.wav": "NmHS",
	"./test/3.wav": "00RK",
	"./test/4.wav": "FpfC",
	"./test/5.wav": "5x6Y",
	"./test/6.wav": "beNQ",
	"./test/7.wav": "5Vut"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9I9L";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio ^\.\/.*\.wav$
// module id = 9I9L
// module chunks = 0